export const createPrintJob = async ({ axios, projectId, itemIds, itemType, printSettings }) => {
  const { data } = await axios.post('print-jobs', {
    projectId,
    itemIds,
    itemType,
    printSettings,
  })

  return data
}

export const generatePrintJobPdf = async ({ axios, printJobId }) => {
  // The PDF is rendered by a headless browser in a UTC Lambda, so every date on
  // the print view ("Stand:", photo capture dates) would come out shifted
  // against the on-screen preview. Send the viewer's IANA zone along so the
  // renderer can emulate it — same idea as the browser locale the server
  // already forwards.
  const { timeZone } = Intl.DateTimeFormat()
    .resolvedOptions()

  const { data } = await axios.post(`print-jobs/${printJobId}/generate-pdf`, {
    browserTimezone: timeZone,
  })

  return data
}

export const getPrintJob = async ({ axios, printJobId }) => {
  const { data } = await axios.get(`print-jobs/${printJobId}`)

  return data
}

export const updatePrintJobSettings = async ({ axios, printJobId, printSettings }) => {
  const { data } = await axios.put(`print-jobs/${printJobId}`, {
    printSettings,
  })

  return data
}
